<template>

  <div class="px-4 py-3 text-base leading-5 text-center text-white lg:text-lg bg-lifeboost-red font-ww-medium">
    40% off + up to 8 free gifts! You're not lazy. Your brain is just exhausted from running on sugar and TikTok.
  </div>

</template>